// extracted by mini-css-extract-plugin
export default {"modify_order_header":"vC","center":"wC","empty":"xC","pending":"yC","referralTitle":"zC","wrapper":"AC","title":"BC","tabs":"CC","tab":"EC","active":"FC","btn":"GC","rewards_table":"HC"};
    if(module.hot) {
      // 1738064241559
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  